module.exports = __webpack_public_path__ + "img/85800.07e20bbc.jpg";